<template>
  <section id="modes" class="modes">
    <div class="container">
      <div class="modes-grid">
        <div class="mode-card" :class="{ visible: visible }" ref="card1">
          <div class="mode-header">
            <IconSvg name="sword" class="mode-icon" />
            <h3>{{ t('modes.solo.title') }}</h3>
          </div>
          <p>{{ t('modes.solo.desc') }}</p>
          <div class="mode-tags">
            <span v-for="tag in soloTags" :key="tag" class="mode-tag">{{ tag }}</span>
          </div>
        </div>
        <div class="mode-card" :class="{ visible: visible }" ref="card2">
          <div class="mode-header">
            <div class="team-icons">
              <IconSvg name="red-circle" />
              <IconSvg name="blue-circle" />
            </div>
            <h3>{{ t('modes.pvp.title') }}</h3>
          </div>
          <p>{{ t('modes.pvp.desc') }}</p>
          <div class="mode-tags">
            <span v-for="tag in pvpTags" :key="tag" class="mode-tag">{{ tag }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import IconSvg from './IconSvg.vue'

const { t, tm } = useI18n()
const soloTags = computed(() => tm('modes.solo.tags'))
const pvpTags = computed(() => tm('modes.pvp.tags'))

const card1 = ref(null)
const card2 = ref(null)
const visible = ref(false)

onMounted(() => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        visible.value = true
        observer.unobserve(entry.target)
      }
    })
  }, { threshold: 0.2 })
  if (card1.value) observer.observe(card1.value)
  if (card2.value) observer.observe(card2.value)
})
</script>

<style scoped>
.modes {
  padding: 4rem 0;
  background: var(--bg-light);
}
.modes-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}
.mode-card {
  background: #fff;
  border-radius: 24px;
  padding: 2.5rem;
  box-shadow: 0 4px 24px rgba(0,0,0,0.04);
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease;
}
.mode-card.visible {
  opacity: 1;
  transform: translateY(0);
}
.mode-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}
.mode-icon {
  width: 40px;
  height: 40px;
  color: var(--text-dark);
}
.team-icons {
  display: flex;
  gap: 0.5rem;
}
.team-icons svg {
  width: 32px;
  height: 32px;
}
.mode-card h3 {
  font-size: 1.5rem;
  color: var(--text-dark);
  margin: 0;
}
.mode-card p {
  color: #6b5f5a;
  line-height: 1.8;
  margin-bottom: 1.5rem;
}
.mode-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}
.mode-tag {
  background: rgba(255, 107, 53, 0.1);
  color: var(--accent);
  padding: 0.35rem 0.85rem;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
}
@media (max-width: 900px) {
  .modes-grid {
    grid-template-columns: 1fr;
  }
}
</style>
